import { render, staticRenderFns } from "./HostelRooms.vue?vue&type=template&id=52275dba"
import script from "./HostelRooms.vue?vue&type=script&lang=js"
export * from "./HostelRooms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports